"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainNav = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _swatches = require("../swatches");

var _mainNav = require("../light/mainNav");

var _base = require("./base");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mainNav = _objectSpread(_objectSpread({}, _mainNav.mainNav), {}, {
  headerColor: _swatches.monochrome.white,
  controlIconColor: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.5)"),
  controlIconColorHover: _swatches.monochrome.white,
  controlIconHoverBackgroundOpacity: 0.3,
  background: _swatches.monochrome.hyperDark,
  color: _swatches.monochrome.white,
  highlightColor: _swatches.brand['300'],
  itemBackgroundActive: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.25)"),
  itemBackgroundHover: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.1)"),
  iconColor: _swatches.monochrome.white,
  alertColor: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.7)"),
  alertColorHover: _swatches.monochrome.white,
  alertColorActive: _swatches.monochrome.white,
  countColor: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.7)"),
  countColorHover: _swatches.monochrome.white,
  countColorActive: _swatches.monochrome.white,
  dividerColor: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.1)"),
  optionsBtnBackgroundHover: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.25)"),
  optionsIconColor: "rgba(".concat(_swatches.monochrome.white_rgba, ", 0.75)"),
  warningIconColor: _swatches.warning['700'],
  composeButtonColor: _swatches.grey[100],
  composeButtonBackground: _swatches.monochrome.hyperDark,
  composeButtonBorder: _swatches.grey[100],
  composeButtonColorHover: _swatches.monochrome.white,
  composeButtonBackgroundHover: _swatches.monochrome.hyperDark,
  composeButtonBorderHover: _base.primary.white
});

exports.mainNav = mainNav;
//# sourceMappingURL=mainNav.js.map